<template>
  <div>
    <Image
      src="withdrawal_balance_info"
      alt="Withdrawal balance info"
      class="mx-auto mb-6"
    />

    <NText variant="caption1" weight="regular">
      {{ t('withdrawal.withdrawalBalanceInfo.message') }}
    </NText>

    <ul class="mt-3 pr-3 list-disc mb-6">
      <li
        v-for="(item, index) in WITHDRAWAL_BALANCE_ITEMS"
        :key="index"
        class="mb-2 marker:text-brand-primary"
      >
        <NText variant="caption1" weight="regular" class="relative -top-[2px]">
          {{ item }}
        </NText>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import Image from '@/components/Image.vue';

const { t } = useI18n();

const WITHDRAWAL_BALANCE_ITEMS = [
  t('withdrawal.withdrawalBalanceInfo.openBuyOrders'),
  t('withdrawal.withdrawalBalanceInfo.openWithdrawalBalanceRequests'),
  t('withdrawal.withdrawalBalanceInfo.doneSellOrders'),
];
</script>
